import { makeStyles, MenuItem, TableCell, TextField } from "@material-ui/core";
import React from "react";
import { Language, LanguageLabels } from "../../../../../data/constants";

const useStyles = makeStyles({
  languageCell: {
    width: "200px",
  },
});

type LanguageSelectorCellProps = {
  selectedLanguage?: Language;
  onLanguageChange: (language: Language) => void;
  disabled: boolean;
  availableLanguages?: Language[];
};

const LanguageSelectorCell = ({
  selectedLanguage,
  onLanguageChange,
  disabled,
  availableLanguages,
}: LanguageSelectorCellProps) => {
  const classes = useStyles();

  const languageOptions = availableLanguages
    ? availableLanguages.map((lang) => (
        <MenuItem key={lang} value={String(lang)}>
          {LanguageLabels[lang as Language]}
        </MenuItem>
      ))
    : [];

  return (
    <TableCell className={classes.languageCell}>
      <TextField
        select
        value={String(selectedLanguage)}
        onChange={(event) => onLanguageChange(event.target.value as Language)}
        disabled={disabled || languageOptions.length === 1}
        fullWidth
      >
        {languageOptions}
      </TextField>
    </TableCell>
  );
};

export default LanguageSelectorCell;
